export const TRACK_PROGRAM_SPLIT_CHANGE_EVENT = 'cp-track-program-split-changed';

function key(workspaceId: string, gradeId: string): string {
  return `cp.trackProgramSplit.v1.${workspaceId}.${gradeId}`;
}

export function loadTrackProgramSplitMap(workspaceId: string, gradeId: string): Record<string, boolean> {
  if (!workspaceId || !gradeId) return {};
  try {
    const raw = window.localStorage.getItem(key(workspaceId, gradeId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, boolean> = {};
    Object.entries(parsed as Record<string, unknown>).forEach(([trackName, enabled]) => {
      if (!trackName.trim()) return;
      out[trackName] = enabled === true;
    });
    return out;
  } catch {
    return {};
  }
}

export function saveTrackProgramSplitMap(
  workspaceId: string,
  gradeId: string,
  value: Record<string, boolean>
): void {
  if (!workspaceId || !gradeId) return;
  try {
    const storageKey = key(workspaceId, gradeId);
    const serialized = JSON.stringify(value);
    if (window.localStorage.getItem(storageKey) === serialized) return;
    window.localStorage.setItem(storageKey, serialized);
    window.dispatchEvent(new CustomEvent(TRACK_PROGRAM_SPLIT_CHANGE_EVENT));
  } catch {
    /* ignore quota */
  }
}
